// @flow
import React, { Component } from "react";
import DrawerMenu from "./DrawerMenu";
import Drawer from "@material-ui/core/Drawer";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import type { MenuItem } from "containers/PublicApp/types";

const styles = (theme) => ({
  persistent: {
    position: "fixed",
    overflowY: "auto",
  },
  drawerPaper: {
    position: "relative",
    width: 310,
  },
});

type Props = {
  persistent?: boolean,
  open: boolean,
  handleRequestClose: Function,
  space?: string,
  menuBorder?: boolean,
  items: Array<MenuItem>,
  classes: Object,
  openSide: string,
};

type State = {
  expanded: number,
};

class PublicSidebar extends Component<Props, State> {
  state: State;

  constructor(props: Props) {
    super(props);
    this.state = {
      menuData: null,
      expanded: 0,
    };
  }

  setExpanded = () => {
    const { space, items } = this.props;
    if (space && items && items.length > 0) {
      const index = items.findIndex((value) => value.link === `/${space}`);
      if (index !== -1) {
        this.setState({ expanded: index });
      }
    }
  };

  handleExpandedChange = (idx: number) => {
    this.setState({ expanded: idx });
  };

  render() {
    const { items, handleRequestClose, persistent, classes, openSide } =
      this.props;
    if (!items || items.length === 0) {
      return null;
    }

    // console.log(items);
    return persistent ? (
      <Paper elevation={0} className={classes.persistent}>
        <DrawerMenu
          expanded={this.state.expanded}
          closeDrawer={this.props.handleRequestClose}
          items={this.props.items}
          onExpandedChange={this.handleExpandedChange}
          persistent={persistent}
        />
      </Paper>
    ) : (
      <Drawer
        variant="temporary"
        className={classes.drawerPaper}
        anchor={openSide}
        open={this.props.open}
        onClose={handleRequestClose}
        ModalProps={
          { keepMounted: true } // Better open performance on mobile.
        }
      >
        <DrawerMenu
          expanded={this.state.expanded}
          closeDrawer={this.props.handleRequestClose}
          items={this.props.items}
          onExpandedChange={this.handleExpandedChange}
          persistent={persistent}
        />
      </Drawer>
    );
  }
}

export default withStyles(styles)(PublicSidebar);
